import React, { Component } from "react";
import { random } from "faker";

import { configs, themes, colors } from "./configs";
import { detectBrowser, interpolateRgb, loadJson } from "./utils";

import { MapViz } from "./map-viz";
import { Slider } from "./components/slider/index";
import { ScenarioContent } from "./components/scenario-content";
import { TravelTime } from "./components/travel-time";
import { Dropdown } from "./components/dropdown/index";
import { Passenger } from "./components/passenger";

import style from "./app.module.css";

class App extends Component {
  constructor(props) {
    super(props);

    this.onScenarioChange = this.onScenarioChange.bind(this);
    this.onSliderChange = this.onSliderChange.bind(this);
    this.setState = this.setState.bind(this);

    const isIpad = navigator.userAgent.match(/iPad/i) !== null;
    const themeName = (window.location.search === "?dark" || window.location.pathname === "/dark" || window.location.href.includes("ingoltest")) ? "dark" : "light";
    console.log(window.location);

    this.state = {
      isIpad,
      selectedScenarioOption: null,
      scenarioCode: "sc-0",
      avPercent: 0,
      sliderColor: this.calcAvColor(0),
      isNarrow: null,
      theme: themes[themeName],
      themeName,
      browser: null,
      data: null,
      menuOptions: [],
      showMenuIndicator: true,
      minAvPercentInThisScenario: 0,
      sliderValue: 0,
      showAppTitle: true,
      showEmbedInfo: false,
    };
  }

  componentDidMount() {
    if (typeof document !== "undefined") {
      this.setState({
        browser: detectBrowser()
      });
      document.body.style.background = this.state.theme.appBackground;
      window.addEventListener("resize", this.onResize);
      window.addEventListener("scroll", this.onScroll);

      this.onResize();
      this.onScroll();
    }

    if (this.state.data === null) {
      loadJson("/scenarios.json").then(data => {
        const menuOptions = Object.keys(data.scenarios).map(
          (scenarioName, index) => ({
            key: scenarioName,
            label: data.scenarios[scenarioName][0].scenario_name,
            index
          })
        );

        this.setState({
          data: data,
          menuOptions
        });
      });
    }
  }

  componentWillUnmount() {
    if (typeof document !== "undefined") {
      window.removeEventListener("resize", this.onResize);
      window.removeEventListener("scroll", this.onScroll);
    }
  }

  onScroll = () => {
    if (this.state.isIpad) {
      return;
    }

    if (window.scrollY > 10) {
      this.setState({
        showAppTitle: false
      });
    } else {
      this.setState({
        showAppTitle: true
      });
    }
  };

  onResize = () => {
    if (this.state.isIpad) {
      const orientation =
        window.innerWidth > window.innerHeight ? "landscape" : "portrait";
      if (orientation !== this.state.orientation) {
        this.setState({ orientation });
      }
    }
  };

  onScenarioChange = option => {
    const { avPercent, data: { scenarios } } = this.state;
    const records = scenarios[option.key];
    const avs = records.map(r => r.av);
    const minAvPercentInThisScenario = Math.min(...avs);
    const av =
      avs.indexOf(avPercent) > -1 ? avPercent : minAvPercentInThisScenario;

    this.setState({
      scenarioCode: option.key,
      showMenuIndicator: false,
      avPercent: av,
      sliderValue: av,
      minAvPercentInThisScenario: minAvPercentInThisScenario
    });
  };

  onSliderChange = sliderValue => {
    const avPercent = this.sliderValueToAvPercent(sliderValue);
    this.setState({
      sliderValue,
      sliderColor: this.calcAvColor(avPercent)
    });
  };

  onSliderAfterChange = sliderValue => {
    //only update avPercent if we slider is stop at one point!
    //otherwise there would be un necessary data fetching for points which are passed by too
    this.setState({
      avPercent: this.sliderValueToAvPercent(sliderValue),
      sliderValue
    });
  };

  sliderValueToAvPercent = sliderValue => {
    return ~~(sliderValue / 20) * 20;
  };

  calcMapWidth = () => {
    const { padding } = configs;
    return `calc(100vw - calc(2* ${padding}px))`;
  };

  calcMapHeight = () => {
    const { mapHeightPercent, padding } = configs;
    return `calc(${100 * mapHeightPercent}vh - ${padding}px)`;
  };

  calcAvColor = avPercent => {
    return interpolateRgb(avPercent * 0.9);
  };

  getCurrentScenarioData = () => {
    const { scenarioCode, data, avPercent } = this.state;

    const scenarioText = data.texts.find(
      text => text.scenario_code === scenarioCode
    );
    const scenarioRecord = data.scenarios[scenarioCode].find(
      r => r.av === avPercent
    );

    return {
      ...scenarioRecord,
      text: scenarioText ? scenarioText.scenario_text : ""
    };
  };
  
  
  showEmbedInfo = () => {
    this.setState({
      showEmbedInfo: true
    });
  }
  
  hideEmbedInfo = (e) => {
    if(e && e.target && ["closeModal", "embedInfo"].find(it => e.target.className.includes(it))){
      this.setState({
        showEmbedInfo: false,
      });
    }
  }

  render() {
    const { padding, sliderSteps, mapStyle } = configs;
    const {
      sliderColor,
      avPercent,
      themeName,
      theme,
      browser,
      data,
      menuOptions,
      scenarioCode,
      sliderValue,
      showMenuIndicator,
      minAvPercentInThisScenario,
      isIpad,
      showAppTitle
    } = this.state;

    if (data === null) {
      return null;
    }

    const currentScenario = this.getCurrentScenarioData();
    const mapHeight = this.calcMapHeight();
    const mapWidth = this.calcMapWidth();

    return (
      <div
        className={`app ${style.wrapper} ${themeName}`}
        style={{
          padding: `${padding}px`,
          backgroundColor: theme.appBackground
        }}
      >
        {data === null ? (
          <div>loading</div>
        ) : (
          <div>
            <div
              className={style.header}
              style={{
                backgroundColor: theme.appBackground
              }}
            >
              <div
                className={`${style.appTitle} ${
                  showAppTitle ? "" : style.appTitleHide
                }`}
              >
                <span
                  className={"subTitle"}
                  style={{
                    color: theme.iconBackground
                  }}
                >
                  AUDI 25TH HOUR
                </span>
                <span className={"title"}>
                  simulation of future traffic in ingolstadt/germany
                </span>
              </div>

              <Dropdown
                options={menuOptions}
                onChange={this.onScenarioChange}
                selectedCode={scenarioCode}
                css={{
                  background: theme.menuBackground
                }}
                showIndicator={showMenuIndicator}
                onIndicatorClick={() => {
                  this.setState({ showMenuIndicator: false });
                }}
              />
            </div>

            <div className={style.appBody}>
              <MapViz
                padding={padding}
                width={"100%"}
                height={mapHeight}
                mapStyle={mapStyle}
                scenarioCode={scenarioCode}
                avPercent={avPercent}
              >
                <TravelTime
                  timeValue={currentScenario.travel_time}
                  timeGainValue={currentScenario.travel_time_gain}
                  disabled={currentScenario === null}
                  staticContent={data.staticContent.travel_time[0]}
                />
                <Passenger
                  value={currentScenario.persons_network}
                  theme={theme}
                  color={colors.colors.red}
                  disabled={currentScenario === null}
                  staticContent={data.staticContent.persons_network[0]}
                />

                <div className={`mapStatus ${style.legend}`}>
                  <span className={"subTitle"}>optimal flow</span>
                  <img src={"icons/legend.svg"} />
                </div>

                <div className={`mapStatus ${style.mapText}`}>
                  <p>
                    <span className={"subTitle"}>
                      the traffic flow reflects
                    </span>
                    <span className={"subTitle"}>the morning rush-hour</span>
                  </p>
                </div>
              </MapViz>

              <div className={style.contentWrapper}>
                <div>
                  <Slider
                    onChange={this.onSliderChange}
                    onAfterChange={this.onSliderAfterChange}
                    max={100}
                    value={sliderValue * 10}
                    steps={sliderSteps}
                    theme={theme}
                    themeName={this.state.themeName}
                    minValue={minAvPercentInThisScenario * 10}
                  />
                </div>

                <div className={style.scenarioContentWrapper}>
                  <ScenarioContent
                    data={currentScenario}
                    sliderColor={sliderColor}
                    theme={theme}
                    themeName={themeName}
                    staticContent={data.staticContent}
                  />
                  <p
                    dangerouslySetInnerHTML={{ __html: currentScenario.text }}
                  />
                </div>
                <div className={style.footnote} onClick={this.showEmbedInfo}>
                  Embed this traffic simulation into your article/website
                </div>
              </div>
            </div>
          </div>
        )}
      {this.state.showEmbedInfo &&
       <div className={style.embedInfo} onClick={this.hideEmbedInfo}>
         <div className={style.modal}>
           <p className={style.modalText}>
             Include the following html in your article / website to embed the simulation:
           </p>
           <div className={style.embedSnippetContainer}>
             <code>
                &lt;iframe style="width: 100%; height: 100%;border-width: 0px;" src="https://25thhour.rndr.studio"&gt;&lt;/iframe&gt;
             </code>
           </div>
           <p className={style.modalText}>
              The applet will adapt to the width and height of its parent element.
           </p>
           <div className={style.closeModal} onClick={this.hideEmbedInfo}>
             Close
           </div>
         </div>
       </div>
      }
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/app.js